const closeButtonLabel = "Close";
const enAU = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  enAU as default
};
